import Categories from './Categories'
import Countries from './Countries'
import Dates from './Dates'
import Fcp from './Fcp'
import Search from './Search'
import Reset from './Reset'

const Filter = {}

Filter.Categories = Categories
Filter.Countries = Countries
Filter.Dates = Dates
Filter.Fcp = Fcp
Filter.Search = Search
Filter.Reset = Reset

export default Filter
